import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { checklistsApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useDeleteChecklist = (options?: UseMutationOptions<void, unknown, string>) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, string>(
    ['delete-checklist', assetId],
    async (checklistId: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await checklistsApi.checklistsControllerRemove(checklistId, assetId);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries('fetch-checklists');
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
        trackEvent('Checklist', 'delete');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
